<!--
 * @Descripttion: 
 * @version: 
 * @Author: wangliuyang
 * @Date: 2023-04-04 15:43:17
 * @LastEditors: wangliuyang
 * @LastEditTime: 2023-06-26 18:46:36
-->
<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title"></router-view>
  </div>
</template>

<script>
import store from "@/store";
import router from '@/router';
import Vue from 'vue'
export default {
  name: "App",

    computed: {
        _isMobile () {
            const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
            return flag;
        }
    },
    
    mounted () {
        // 检查登录状态
        this.getLoginStats();
        // 移动端 跳转到对应路径
        if (this._isMobile) {
            this.$router.replace('/indexFe');
        } else {
            // PC端
        }
    },

  watch: {
    //监听路由变化
    $route: {
      handler() {
        if (this.$route) {
          this.getLoginStats();
        }
        return;
      },
      immediate: true,
    },
  },

  methods: {
    //检查登录状态
    getLoginStats() {
      //手机跳出
      // if(this.$isFe) return;
      //首页和登录等路由 不需要验证登录
      let routeArr = [
        "/",
        "/index",
        "/indexFe",
        "/downApp",
        "/schoolIndex",
        "/loginCode",
        "/loginPassword",
        "/refundProtocol",
        "/teachersTeam",
        "/about",
        "/contact",
        "/schoolDetail"
      ];
      if (routeArr.includes(this.$router.currentRoute.path)) return;
      console.log(store.state.user);
      const studentCode =  store.state.user.Code;
      if (!studentCode) {
        // Vue.prototype.$toast.center("未登录，请先登录");
        localStorage.removeItem("user");
        router.replace({
          path: "/loginCode",
          query: {
            redirect: router.currentRoute.fullPath,
          },
        });
      }

      // let query = {
      //   type: 1
      // };
      // let option = {
      //   type: "get",
      //   api: "/user/loginstate",
      //   query: query
      // };
      // this.$request(option, res => {
      //   console.err('data','token 过期则跳转登录')
      // });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue